module.exports = __webpack_public_path__ + "img/power-plant-icon.693bab9c.svg";